module.exports = __webpack_public_path__ + "static/media/reconnect.9d4356e8.png";